import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-user-review',
  templateUrl: './user-review.component.html',
  styleUrls: ['./user-review.component.scss'],
})
export class UserReviewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    stagePadding: 0,
    autoHeight:false,
    smartSpeed: 1000,
    dotsEach: false,
    freeDrag: true,
    margin: 20,
    navText: [
      '<span class="material-icons">chevron_left</span>',
      '<span class="material-icons">chevron_right</span>',
    ],
    responsive: {
      0: {
        items: 1,
        dotsEach: false,
        autoHeight:true
      },
      300: {
        items: 1,
        dotsEach: false,
        autoHeight:true
      },
      500: {
        items: 1,
        autoHeight:false
      },
      767: {
        items: 1,
        autoHeight:false
      },
      992: {
        items: 3,
        autoHeight:false
      },
      1463: {
        items: 3,
        autoHeight:false
      },
      1920: {
        items: 3,
        autoHeight:false
      },
    },
    nav: true,
  };
}
